import { YesNoValue, CSV_VALUES } from '../constants';

export function formatYesNo(value: boolean): YesNoValue {
  return value ? CSV_VALUES.YES : CSV_VALUES.NO;
}